import { render, staticRenderFns } from "./AochenFooter.vue?vue&type=template&id=2b8ad83c&scoped=true"
import script from "./AochenFooter.vue?vue&type=script&lang=js"
export * from "./AochenFooter.vue?vue&type=script&lang=js"
import style0 from "./AochenFooter.vue?vue&type=style&index=0&id=2b8ad83c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8ad83c",
  null
  
)

export default component.exports